import React from "react";

function SanctionPartPaymentCharges() {
    return (
        <>
            <div className="relative w-full">
                <ul className="list-disc pl-5">
                    <li className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1 mb-3">
                        Part-payment is allowed subject to completion of 12
                        months (i.e., Post payment of 12 EMIs)
                    </li>
                    <li className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1 mb-3">
                        Part payment will be allowed twice only during loan
                        tenure
                    </li>
                    <li className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1 mb-3">
                        Part payment is allowed only once a year
                    </li>
                    <li className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1 mb-3">
                        At any point of time, part payment will not increase
                        beyond 25% of Principal Outstanding
                    </li>
                    <li className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1 mb-3">
                        5% on the part payment amount in case part prepayment is
                        within 13- 24 months from 1st EMI
                    </li>
                    <li className="openSans-Reg text-sm md:text-lg xl:text-xl grayshade-1">
                        3% on the part payment amount in case part prepayment is
                        post 24 months from 1st EMI
                    </li>
                </ul>
            </div>
        </>
    );
}

export default SanctionPartPaymentCharges;
